import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";

const RenderDatePicker = ({
  input,
  label,
  value,
  defaultValue,
  meta: { touched, error },
}) => {
  return (
    <div style={{ marginTop: "10px", marginBottom: "20px" }}>
      <InputLabel
        id="demo-simple-select-autowidth-label"
        style={{
          fontFamily: "GT-Walsheim-medium",
          fontSize: "11px",
          color: "black",
          top: "10px",
        }}
      >
        {label}
      </InputLabel>
      <DatePicker
        selected={input.value}
        onChange={input.onChange}
        value={input.value}
        dateFormat="dd/MM/yyyy"
        InputLabelProps={{
          style: {
            color: "black",
            fontFamily: "GT-Walsheim-medium",
            fontSize: "14px",
          },
        }}
      />
      {touched && error && (
        <div style={{ color: "red", fontSize: ".7em" }}>
          <i className="fa fa-exclamation-circle">{error}</i>
        </div>
      )}
    </div>
  );
};

export default RenderDatePicker;
